import { combineReducers } from 'redux';

import activitiesSearch from './activities/search/reducer';
import comments from './comments/reducer';
import deal from './deal/reducer';
import fields from './fields/reducer';
import invalidFields from './invalid_fields/reducer';
import overview from './overview/reducer';
import plannerFilters from './planner_filters/reducer';
import plannerBulkActions from './planner_bulk_actions/reducer';
import relatedDeals from './related_deals/reducer';
import tasks from './tasks/reducer';

export default combineReducers({
  activitiesSearch,
  availableSummaryModels: availableSummaryModels => availableSummaryModels || [],
  comments,
  deal,
  features: features => features || {},
  fields,
  forUser: forUser => forUser || {},
  invalidFields,
  options: options => options || {},
  overview,
  parentDeal: parentDeal => parentDeal || {},
  paths: paths => paths || {},
  leadsTabProps: leadsTabProps => leadsTabProps || {},
  plannerFilters,
  plannerBulkActions,
  relatedDeals,
  stagesConfig: stagesConfig => stagesConfig || {},
  tasks,
});
